<div class="notification-menu">
  <div class="menu-title">
    <h2 class="menu-title-text">Notifications</h2>
    <button class="close-button">
      <img alt="Close Button" src="assets/icons/common/close.svg">
    </button>
  </div>
  @if (hasNotifications()) {
    <div class="notifications">
      <ul class="notifications-list">
        @for (notification of notifications(); track notification.id) {
          <li class="notification-list-item">
            <app-notification-item [notification]="notification"></app-notification-item>
          </li>
        }
      </ul>
    </div>
  } @else {
    <div class="no-data">No notifications</div>
  }
</div>
